import React from "react";
import packageJson from "../../package.json";

export default function Footer() {
  return (
    <footer className="fixed bottom-0 right-0 p-2 text-xs text-gray-400">
      v{packageJson.version}
    </footer>
  );
}
